import {
  add,
  removeAll,
} from '../manageVideoPlayerOverlays';
import { VideoOverlayType } from '../../state/VideoOverlay';
import { State, VideoPlayerError } from '../../state';

export const updateOverlay = (state: State, error: VideoPlayerError | null): void => {
  removeAll(state, (overlay) => overlay.type === VideoOverlayType.Error);

  if (error == null) return;

  add(state, { error: error.error });
};
